// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/pushset/v1/pushset.proto" (package "c1.api.pushset.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
/**
 * PushSet represents a push set in the system
 *
 * @generated from protobuf message c1.api.pushset.v1.PushSet
 */
export interface PushSet {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: bool disabled = 4;
     */
    disabled: boolean;
}
/**
 * PushSetRef represents a reference to a PushSet
 *
 * @generated from protobuf message c1.api.pushset.v1.PushSetRef
 */
export interface PushSetRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * PushSetConnectorBinding represents a binding between a push set and connector
 *
 * @generated from protobuf message c1.api.pushset.v1.PushSetConnectorBinding
 */
export interface PushSetConnectorBinding {
    /**
     * @generated from protobuf field: string pushset_id = 1;
     */
    pushsetId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
}
/**
 * PushSetUserAttributeMappingBinding represents a binding between a push set and user attribute mapping
 *
 * @generated from protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBinding
 */
export interface PushSetUserAttributeMappingBinding {
    /**
     * @generated from protobuf field: string pushset_id = 1;
     */
    pushsetId: string;
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 2;
     */
    userAttributeMappingId: string;
}
// Request messages for PushSetService

/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceGetRequest
 */
export interface PushSetServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceGetResponse
 */
export interface PushSetServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.pushset.v1.PushSet pushset = 1;
     */
    pushset?: PushSet;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceCreateRequest
 */
export interface PushSetServiceCreateRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceCreateResponse
 */
export interface PushSetServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.pushset.v1.PushSet pushset = 1;
     */
    pushset?: PushSet;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceUpdateRequest
 */
export interface PushSetServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.pushset.v1.PushSet pushset = 1;
     */
    pushset?: PushSet;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceUpdateResponse
 */
export interface PushSetServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.pushset.v1.PushSet pushset = 1;
     */
    pushset?: PushSet;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceDeleteRequest
 */
export interface PushSetServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetServiceDeleteResponse
 */
export interface PushSetServiceDeleteResponse {
}
// Request messages for PushSetSearchService

/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetSearchRequest
 */
export interface PushSetSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetRef refs = 4;
     */
    refs: PushSetRef[];
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetSearchResponse
 */
export interface PushSetSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSet list = 1;
     */
    list: PushSet[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// Request messages for PushSetConnectorBindingService

/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceListRequest
 */
export interface PushSetConnectorBindingServiceListRequest {
    /**
     * @generated from protobuf field: string pushset_id = 1;
     */
    pushsetId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceListResponse
 */
export interface PushSetConnectorBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetConnectorBinding list = 1;
     */
    list: PushSetConnectorBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceUpdateRequest
 */
export interface PushSetConnectorBindingServiceUpdateRequest {
    /**
     * @generated from protobuf field: string pushset_id = 1;
     */
    pushsetId: string;
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetConnectorBinding bindings = 2;
     */
    bindings: PushSetConnectorBinding[];
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceUpdateResponse
 */
export interface PushSetConnectorBindingServiceUpdateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetConnectorBinding bindings = 1;
     */
    bindings: PushSetConnectorBinding[];
}
// Request messages for PushSetUserAttributeMappingBindingService

/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceListRequest
 */
export interface PushSetUserAttributeMappingBindingServiceListRequest {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceListResponse
 */
export interface PushSetUserAttributeMappingBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetUserAttributeMappingBinding list = 1;
     */
    list: PushSetUserAttributeMappingBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceUpdateRequest
 */
export interface PushSetUserAttributeMappingBindingServiceUpdateRequest {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetUserAttributeMappingBinding bindings = 2;
     */
    bindings: PushSetUserAttributeMappingBinding[];
}
/**
 * @generated from protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceUpdateResponse
 */
export interface PushSetUserAttributeMappingBindingServiceUpdateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.pushset.v1.PushSetUserAttributeMappingBinding bindings = 1;
     */
    bindings: PushSetUserAttributeMappingBinding[];
}
// @generated message type with reflection information, may provide speed optimized methods
class PushSet$Type extends MessageType<PushSet> {
    constructor() {
        super("c1.api.pushset.v1.PushSet", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "1000" } } } },
            { no: 4, name: "disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSet
 */
export const PushSet = new PushSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetRef$Type extends MessageType<PushSetRef> {
    constructor() {
        super("c1.api.pushset.v1.PushSetRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetRef
 */
export const PushSetRef = new PushSetRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetConnectorBinding$Type extends MessageType<PushSetConnectorBinding> {
    constructor() {
        super("c1.api.pushset.v1.PushSetConnectorBinding", [
            { no: 1, name: "pushset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetConnectorBinding
 */
export const PushSetConnectorBinding = new PushSetConnectorBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetUserAttributeMappingBinding$Type extends MessageType<PushSetUserAttributeMappingBinding> {
    constructor() {
        super("c1.api.pushset.v1.PushSetUserAttributeMappingBinding", [
            { no: 1, name: "pushset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBinding
 */
export const PushSetUserAttributeMappingBinding = new PushSetUserAttributeMappingBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceGetRequest$Type extends MessageType<PushSetServiceGetRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceGetRequest
 */
export const PushSetServiceGetRequest = new PushSetServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceGetResponse$Type extends MessageType<PushSetServiceGetResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceGetResponse", [
            { no: 1, name: "pushset", kind: "message", T: () => PushSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceGetResponse
 */
export const PushSetServiceGetResponse = new PushSetServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceCreateRequest$Type extends MessageType<PushSetServiceCreateRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceCreateRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "255" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxLen: "1000" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceCreateRequest
 */
export const PushSetServiceCreateRequest = new PushSetServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceCreateResponse$Type extends MessageType<PushSetServiceCreateResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceCreateResponse", [
            { no: 1, name: "pushset", kind: "message", T: () => PushSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceCreateResponse
 */
export const PushSetServiceCreateResponse = new PushSetServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceUpdateRequest$Type extends MessageType<PushSetServiceUpdateRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceUpdateRequest", [
            { no: 1, name: "pushset", kind: "message", T: () => PushSet },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceUpdateRequest
 */
export const PushSetServiceUpdateRequest = new PushSetServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceUpdateResponse$Type extends MessageType<PushSetServiceUpdateResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceUpdateResponse", [
            { no: 1, name: "pushset", kind: "message", T: () => PushSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceUpdateResponse
 */
export const PushSetServiceUpdateResponse = new PushSetServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceDeleteRequest$Type extends MessageType<PushSetServiceDeleteRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceDeleteRequest
 */
export const PushSetServiceDeleteRequest = new PushSetServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetServiceDeleteResponse$Type extends MessageType<PushSetServiceDeleteResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetServiceDeleteResponse
 */
export const PushSetServiceDeleteResponse = new PushSetServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetSearchRequest$Type extends MessageType<PushSetSearchRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetSearchRequest
 */
export const PushSetSearchRequest = new PushSetSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetSearchResponse$Type extends MessageType<PushSetSearchResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSet },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetSearchResponse
 */
export const PushSetSearchResponse = new PushSetSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetConnectorBindingServiceListRequest$Type extends MessageType<PushSetConnectorBindingServiceListRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetConnectorBindingServiceListRequest", [
            { no: 1, name: "pushset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceListRequest
 */
export const PushSetConnectorBindingServiceListRequest = new PushSetConnectorBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetConnectorBindingServiceListResponse$Type extends MessageType<PushSetConnectorBindingServiceListResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetConnectorBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetConnectorBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceListResponse
 */
export const PushSetConnectorBindingServiceListResponse = new PushSetConnectorBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetConnectorBindingServiceUpdateRequest$Type extends MessageType<PushSetConnectorBindingServiceUpdateRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetConnectorBindingServiceUpdateRequest", [
            { no: 1, name: "pushset_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetConnectorBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceUpdateRequest
 */
export const PushSetConnectorBindingServiceUpdateRequest = new PushSetConnectorBindingServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetConnectorBindingServiceUpdateResponse$Type extends MessageType<PushSetConnectorBindingServiceUpdateResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetConnectorBindingServiceUpdateResponse", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetConnectorBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetConnectorBindingServiceUpdateResponse
 */
export const PushSetConnectorBindingServiceUpdateResponse = new PushSetConnectorBindingServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetUserAttributeMappingBindingServiceListRequest$Type extends MessageType<PushSetUserAttributeMappingBindingServiceListRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceListRequest", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceListRequest
 */
export const PushSetUserAttributeMappingBindingServiceListRequest = new PushSetUserAttributeMappingBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetUserAttributeMappingBindingServiceListResponse$Type extends MessageType<PushSetUserAttributeMappingBindingServiceListResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetUserAttributeMappingBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceListResponse
 */
export const PushSetUserAttributeMappingBindingServiceListResponse = new PushSetUserAttributeMappingBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetUserAttributeMappingBindingServiceUpdateRequest$Type extends MessageType<PushSetUserAttributeMappingBindingServiceUpdateRequest> {
    constructor() {
        super("c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceUpdateRequest", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetUserAttributeMappingBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceUpdateRequest
 */
export const PushSetUserAttributeMappingBindingServiceUpdateRequest = new PushSetUserAttributeMappingBindingServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PushSetUserAttributeMappingBindingServiceUpdateResponse$Type extends MessageType<PushSetUserAttributeMappingBindingServiceUpdateResponse> {
    constructor() {
        super("c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceUpdateResponse", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PushSetUserAttributeMappingBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.pushset.v1.PushSetUserAttributeMappingBindingServiceUpdateResponse
 */
export const PushSetUserAttributeMappingBindingServiceUpdateResponse = new PushSetUserAttributeMappingBindingServiceUpdateResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.pushset.v1.PushSetService
 */
export const PushSetService = new ServiceType("c1.api.pushset.v1.PushSetService", [
    { name: "Get", options: { "authz.method": { role: "OWNER" } }, I: PushSetServiceGetRequest, O: PushSetServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "OWNER" } }, I: PushSetServiceCreateRequest, O: PushSetServiceCreateResponse },
    { name: "Update", options: { "authz.method": { role: "OWNER" } }, I: PushSetServiceUpdateRequest, O: PushSetServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" } }, I: PushSetServiceDeleteRequest, O: PushSetServiceDeleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.pushset.v1.PushSetSearchService
 */
export const PushSetSearchService = new ServiceType("c1.api.pushset.v1.PushSetSearchService", [
    { name: "Search", options: { "authz.method": { role: "OWNER" } }, I: PushSetSearchRequest, O: PushSetSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.pushset.v1.PushSetConnectorBindingService
 */
export const PushSetConnectorBindingService = new ServiceType("c1.api.pushset.v1.PushSetConnectorBindingService", [
    { name: "List", options: { "authz.method": { role: "OWNER" } }, I: PushSetConnectorBindingServiceListRequest, O: PushSetConnectorBindingServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "OWNER" } }, I: PushSetConnectorBindingServiceUpdateRequest, O: PushSetConnectorBindingServiceUpdateResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.pushset.v1.PushSetUserAttributeMappingBindingService
 */
export const PushSetUserAttributeMappingBindingService = new ServiceType("c1.api.pushset.v1.PushSetUserAttributeMappingBindingService", [
    { name: "List", options: { "authz.method": { role: "OWNER" } }, I: PushSetUserAttributeMappingBindingServiceListRequest, O: PushSetUserAttributeMappingBindingServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "OWNER" } }, I: PushSetUserAttributeMappingBindingServiceUpdateRequest, O: PushSetUserAttributeMappingBindingServiceUpdateResponse }
]);
